import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Modal, Search } from 'semantic-ui-react';

const inputProps = {
  placeholder: 'Organisation name',
};

const CloneShortlistModal = props => {
  const {
    visible,
    selected,
    closeHandler,
    searchHandler,
    selectedHandler,
    options,
    loading,
    searched,
    yepButtonHandler,
  } = props;
  return (
    <Modal size="small" open={visible}>
      <Modal.Header>Clone shortlist</Modal.Header>
      <Modal.Content>
        <Search
          fluid
          className="full-width"
          input={inputProps}
          loading={loading}
          showNoResults={searched}
          minCharacters={3}
          results={options}
          onSearchChange={searchHandler}
          onResultSelect={selectedHandler}
        />
      </Modal.Content>
      <Modal.Content>
        <span>{(selected && `Clone shortlist to ${selected.title}`) || 'Please choose target organisation'}</span>
      </Modal.Content>
      <Modal.Actions>
        <Button color="pink" onClick={closeHandler}>
          <Icon name="remove" />
            Cancel
        </Button>
        <Button color="green" disabled={!selected} onClick={yepButtonHandler}>
          <Icon name="checkmark" />
            Yep
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

CloneShortlistModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  selected: PropTypes.object.isRequired,
  closeHandler: PropTypes.func.isRequired,
  searchHandler: PropTypes.func.isRequired,
  yepButtonHandler: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selectedHandler: PropTypes.func.isRequired,
  searched: PropTypes.bool.isRequired,
};

export default CloneShortlistModal;



/** WEBPACK FOOTER **
 ** ./src/components/clone-shortlist/index.js
 **/